// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__2-yNy","spinnerBorder":"Loading_spinnerBorder__j_T7o"};